import { memo } from 'react';
import { useFetch } from 'shared/api/hooks';
import { usePromiseResult } from 'shared/hooks/utils';
function RenderWhenReadyImpl(props) {
    const result = usePromiseResult(props.promise, props.clear_on_promise_change);
    if (result == null) {
        return props.loaderComponent;
    }
    if ('error' in result) {
        return props.errorComponent?.(result.error) ?? null;
    }
    return props.children(result.result);
}
export const RenderWhenReady = memo(RenderWhenReadyImpl);
export function RenderWhenReadyFetch(props) {
    const { url, loaderComponent, children, errorComponent } = props;
    const [loading, response, error] = useFetch(url);
    if (loading) {
        return loaderComponent;
    }
    if (error != null) {
        return errorComponent?.(error) ?? null;
    }
    if (response == null) {
        return errorComponent?.('Не получилось отправить запрос') ?? null;
    }
    const { ok, ...rest } = response;
    return children(rest);
}
